/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { createBrowserHistory } from 'history'
import transitionManager from './TransitionManager'

class History {
  length = 0
  location = null
  action = null
  listen = null
  unlisten = null
  createHref = null

  _prevLocation = null

  constructor() {
    this._history = createBrowserHistory()
    let self = this
    this._history.listen((location, action) => {
      switch (action.toUpperCase()) {
        case 'PUSH':
          transitionManager.push(this._prevLocation)
          this._prevLocation = location
          break
        case 'REPLACE':
          this._prevLocation = location
          break
        case 'POP':
          transitionManager.pop()
          this._prevLocation = location
          break
      }
      self.location = location
      self.action = action
    })
    this._prevLocation = this._history.location
    this._update()
  }

  push(path, state) {
    if (path != null) {
      this._history.push(path, state)
    }
  }

  replace(path, state) {
    if (path != null) {
      this._history.replace(path, state)
    }
  }

  go(n) {
    this._history.go(n)
  }

  goBack() {
    this._history.goBack()
  }

  goForward() {
    this._history.goForward()
  }

  canGo(n) {
    const location = transitionManager.peek()
    return location != null
  }

  block(prompt) {
    // this._history.block(prompt)
    throw "Error: history.block(prompt) hasn't Implemented yet."
  }

  canGoBack() {
    return this.backUrl() != null
  }

  backUrl() {
    const location = transitionManager.peek()
    if (location != null) {
      return location.pathname
    }

    return null
  }

  _update() {
    this.length = this._history.length
    this.location = this._history.location
    this.action = this._history.action
    this.listen = this._history.listen
    this.unlisten = this._history.unlisten
    this.createHref = this._history.createHref
  }
}

export default new History()
